var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('list-container-widget',{staticClass:"d-flex",attrs:{"id":"chat","title":"Chat","app-id":97,"view-more-location":_vm.getLocation('chat'),"disable-view-more":false,"size":100,"stretch":"","hidden-actions":""}},[_c('ChatArea2')],1)}
var staticRenderFns = []

export { render, staticRenderFns }